// extracted by mini-css-extract-plugin
export default {"wrapper":"Lq-z","response":"Mq-z","error":"Nq-z","disabled":"Oq-z","buttons":"Pq-z","feedbackQuestionSection":"Qq-z","yesNoWrapper":"Rq-z"};